import { useTheme } from "@mui/material";
import { bestPracticeAlertCircleIcon, bestPracticeCheckCircleIcon, bestPracticeXCircleIcon } from "@common/icons.tsx";
import { BestPracticeCheckFindingType } from "../bestPracticeCheckDialog/BestPracticeCheckDialog.types";

export function useBestPracticeCheckResultView() {
    const theme = useTheme();

    const getFindingTypeColor = (findingType: BestPracticeCheckFindingType) => {
        switch (findingType) {
            case BestPracticeCheckFindingType.FullCompliance:
                return theme.palette.secondary.main;
            case BestPracticeCheckFindingType.PartialCompliance:
                return theme.customPalette.yellow;
            case BestPracticeCheckFindingType.MissingElement:
                return theme.palette.error.main;
        }
    };

    const getFindingTypeIcon = (findingType: BestPracticeCheckFindingType) => {
        switch (findingType) {
            case BestPracticeCheckFindingType.FullCompliance:
                return bestPracticeCheckCircleIcon(theme.palette.secondary.main);
            case BestPracticeCheckFindingType.PartialCompliance:
                return bestPracticeAlertCircleIcon(theme.customPalette.yellow);
            case BestPracticeCheckFindingType.MissingElement:
                return bestPracticeXCircleIcon(theme.palette.error.main);
        }
    };

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text);
    };

    return { getFindingTypeColor, getFindingTypeIcon, copyToClipboard };
}
